import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Icon from '../Icon';
import styles from 'assets/jss/material-dashboard-pro-react/components/notificationPanelStyle';
import { makeStyles } from '@material-ui/core/styles';
import { getNotificationsLabels } from 'redux/modules/dynamicLabels/selectors';
import { ListItemText } from '@material-ui/core';
import { getDayDiff } from 'utils/date/getDate';
import { getLanguage } from 'utils/language/language';
import { setDataLayer } from 'commons/gtm/dataLayerWrapper';
import NotificationButtons from './NotificationButtons';
import { buttonGroupAllowed } from './constant';
import { appConfigSelector } from 'redux/modules/settings/appConfig/selectors';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleNotification {
	id: string;
	createdAt: string;
	title: string;
	description: string;
	read: boolean;
	accId: string;
	notificationSubType: string;
	parameters: Array<{ key: string; value: string }>;
	hideNotification: () => void;
}

const SingleNotification: React.FC<ISingleNotification> = ({
	createdAt,
	title,
	description,
	read,
	accId,
	notificationSubType,
	parameters,
	hideNotification,
}) => {
	const classes = useStyles({
		read: read,
	});
	const notificationsLabels = useSelector(getNotificationsLabels);
	const appConfig = useSelector(appConfigSelector);
	const language = getLanguage();
	const isButtonGroupRequired = buttonGroupAllowed.some((type) => new RegExp(type).test(notificationSubType));
	const notificationIcons: Record<string, string> = appConfig?.notification_icons;
	const icon = notificationIcons[notificationSubType];

	return (
		<div className={classes.listItem}>
			<div
				className={classes.singleWrapper}
				onClick={() => {
					setDataLayer('secondary_navigation', getLanguage(), null, accId, null, {
						link_name: `notification:${title}`,
					});
				}}
			>
				{icon && (
					<div className={classes.iconWrapper} aria-hidden="true">
						<div className={classes.iconCircle}>
							<Icon
								name={icon}
								height="30"
								width="30"
								aria-label={notificationsLabels?.notificationIcon}
							/>
						</div>
					</div>
				)}

				<ListItemText
					className={classes.itemText}
					primary={
						<div className={classes.itemTextContainer}>
							{title}
							<span className={classes.time}>
								{getDayDiff(createdAt) === 0
									? moment(createdAt)
											.locale(language)
											.fromNow()
									: moment(createdAt)
											.locale(language)
											.format('D MMM')}
							</span>
						</div>
					}
					secondary={
						<>
							{description}
							{isButtonGroupRequired && (
								<NotificationButtons
									type={notificationSubType}
									parameters={parameters}
									notificationsLabels={notificationsLabels}
									hideNotification={hideNotification}
								/>
							)}
							{!read && <span className={classes.unReadIndecator}></span>}
						</>
					}
				/>
			</div>
		</div>
	);
};

export default SingleNotification;
